// import { formatDate, parseDate, isDateObject, getWeekNumber } from 'element-ui/src/utils/date-util';
import YearRange from "./YearRange";
// 重写date-range组件
import DateRange from "./date-range.vue";

import { formatDate, isDateObject, prevMonth, nextMonth } from "element-ui/src/utils/date-util";

const HAVE_TRIGGER_TYPES = [
  'date',
  'datetime',
  'time',
  'time-select',
  'week',
  'month',
  'year',
  'daterange',
  'monthrange',
  'timerange',
  'datetimerange',
  'yearrange',
  'dates',
];
const DATE_FORMATTER = function(value, format) {
  if (format === 'timestamp') return value.getTime();
  return formatDate(value, format);
};
const valueEquals = function(a, b) {
  // considers Date object and string
  const dateEquals = function(a, b) {
    const aIsDate = a instanceof Date;
    const bIsDate = b instanceof Date;
    if (aIsDate && bIsDate) {
      return a.getTime() === b.getTime();
    }
    if (!aIsDate && !bIsDate) {
      return a === b;
    }
    return false;
  };

  const aIsArray = a instanceof Array;
  const bIsArray = b instanceof Array;
  if (aIsArray && bIsArray) {
    if (a.length !== b.length) {
      return false;
    }
    return a.every((item, index) => dateEquals(item, b[index]));
  }
  if (!aIsArray && !bIsArray) {
    return dateEquals(a, b);
  }
  return false;
};
let DatePicker = window.ELEMENT.DatePicker;
let dateMixins = DatePicker.mixins[0];
DatePicker.watch = {
  type(type) {
    if (this.picker) {
      this.unmountPicker();
      this.mountPicker();
    }
  }
}

DatePicker.methods={
  handleFocus(){
    if (this.type === 'yearrange') {
      this.panel = YearRange;
    } else if (this.type === 'daterange') {
      if (!this.panel.render_override) {
        let isAddYear = false;
        let year;
        let _this = this;
        const render = this.panel.render;
        this.panel.render = function (h) {
          let vNodes = render.call(this, h);
          if (!isAddYear) {
            // 创建年弹窗
            year = h(DateRange, {
              props: {
                date: new Date(),
                format: _this.format,
                pickerOptions: _this.pickerOptions
              },
              on: {
                pick(val) {
                  if (year.componentInstance.pos === 'left') {
                    _this.picker.leftDate = val;
                    if (!_this.picker.unlinkPanels) {
                      _this.picker.rightDate = nextMonth(val);
                    }
                  } else {
                    _this.picker.rightDate = val;
                    if (!_this.picker.unlinkPanels) {
                      _this.picker.leftDate = prevMonth(val);
                    }
                  }
                }
              }
            });
            vNodes?.componentOptions?.children[0]?.children[0]?.children[1]?.children?.push(year);
          }
          this.$nextTick(() => {
            year.componentInstance.show = false;
            vNodes.elm.querySelector('.is-left .el-date-range-picker__header >div:last-child').onclick = () => {
              year.componentInstance.pos = 'left';
              year.componentInstance.currentView = 'year';
              year.componentInstance.show = true;
            }
            vNodes.elm.querySelector('.is-right .el-date-range-picker__header >div:last-child').onclick = () => {
              year.componentInstance.pos = 'right';
              year.componentInstance.currentView = 'year';
              year.componentInstance.show = true;
            }
          });
          return vNodes;
        }
        this.panel.render_override = true;
      }
    }
    const type = this.type;
    if (HAVE_TRIGGER_TYPES.indexOf(type) !== -1 && !this.pickerVisible) {
      this.pickerVisible = true;
    }
    this.$emit('focus', this);
    this.$emit('update:clearable', true);
  },
  handleRangeClick(){
    this.handleFocus();
  },
  emitInput(val) {
    let formatted;
    if (this.type == 'yearrange') {
      const isFormattable = isDateObject(val) || (Array.isArray(val) && val.every(isDateObject));
      if (this.valueFormat && isFormattable) {
        formatted = [DATE_FORMATTER(val[0], this.valueFormat), DATE_FORMATTER(val[1], this.valueFormat)];
      } else {
        formatted = val;
      }
    } else {
      formatted = this.formatToValue(val);
    }
    if (!valueEquals(this.value, formatted)) {
      this.$emit('input', formatted);
    }
  },
};

DatePicker.computed = {
  displayValue(){
    let displayValue = dateMixins.computed.displayValue
    const values = displayValue.call(this);
    if (this.type === 'yearrange' && this.parsedValue?.length > 0) {
      const parsedValue = typeof this.parsedValue === 'string' ? this.parsedValue.split(',') : this.parsedValue;
      let before = parsedValue[0] === '' ? '' : new Date(parsedValue[0]).getFullYear();
      let after = parsedValue[0] === '' ? '' : new Date(parsedValue[1]).getFullYear();
      if (before && after && this.format) {
        let sdate = new Date(before, 0, 1, 0, 0, 0);
        let edate = new Date(after, 11, 31, 23, 59, 59);
        before = DATE_FORMATTER(sdate, this.format);
        after = DATE_FORMATTER(edate, this.format);
      }
      return [before, after];
    }
    return values;
  },
  haveTrigger() {
    if (typeof this.showTrigger !== 'undefined') {
      return this.showTrigger;
    }
    return HAVE_TRIGGER_TYPES.indexOf(this.type) !== -1;
  },
}